(function($) {

        var wow = new WOW(
      {
        //mobile: false
    }
    )
    wow.init();

    var scrollingFunctions = function() {
        var scrollTop = $(window).scrollTop();

        if(scrollTop > 150) {
            $('header.header>.header-inner').addClass('scrolled-header');
        }

        else if(scrollTop <= 150) {
            $('header.header>.header-inner').removeClass('scrolled-header');
        }

        //parallax effect on header image
        if(scrollTop <= 300) {
            $('.home-header-image').css('transform','translateY(' + scrollTop / 2 +'px)')
        }
    };

    var headerFunction = function() {
        var headerHeight = $('.header-outer').outerHeight();

        $('.off-canvas-content').css('padding-top',headerHeight + 'px');
    };

    $(window).on('load resize',headerFunction);
    $(window).on('load scroll resize',scrollingFunctions);

    var sizeBoxes = function($selector) {
        $($selector).css('height','auto');

        var boxHeight = 0;
        $($selector).each(function(i){
            if($(this).outerHeight() > boxHeight) {
                boxHeight = $(this).outerHeight();
            }
        });

        $($selector).css('height',boxHeight + 'px');
    }

    var postsSlider = function() {
        $('.posts-slider').slick({
            infinite: true,
            arrows: true,
            slidesToShow: 4,
            autoplay: true,
            dots: false,
            centerMode: true,
            appendArrows: $('#posts-slider-arrows'),
            appendDots: $('#posts-slider-dots'),
           responsive: [
             {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                centerMode: true,
              }
            },

            {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
                centerMode: true,
                dots: true,
              }
            },

            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                dots: true,
                arrosw: false,
              }
            },
            ],
          });

        sizeBoxes('.posts-slider header.article-header');

        $('.news-slider').slick({
            infinite: true,
            arrows: true,
            slidesToShow: 1,
            autoplay: true,
            dots: false,
            centerMode: true,
            centerPadding: 'calc((100vw - 75em)/2)',
            appendArrows: $('#news-slider-arrows'),
            appendDotss: $('#news-slider-dots'),
            responsive: [
             {
              breakpoint: 1170,
              settings: {
                centerPadding: '50px',
              }
            },

             {
              breakpoint: 600,
              settings: {
                centerPadding: '25px',
                dots: true,
              }
            },
            ],
          });

        sizeBoxes('.news-slider .post-lower');
        $('.news-slider .slick-slide').css('opacity','1');
        $('.news-slider .slick-slide.slick-current').prev().css('opacity','0');

        $('.testimonials-slider').slick({
            infinite: false,
            arrows: false,
            slidesToShow: 1,
            autoplay: true,
            dots: true,
          });

        sizeBoxes('.testimonials-slider .single-testimonial');
    }

    var sizeHeaderImages = function() {
        var slideHeight = $('.slider-wrapper').outerHeight();

        $('.home-slide-inner').css('height', slideHeight + 'px');
    };

	$(document).ready(function(){
		  $('.home-slider').slick({
		    infinite: true,
		    arrows: false,
		    slidesToShow: 1,
		    autoplay: true,
		    //appendArrows: $('.projects-preview-arrows'),
		    fade: true,
		  });

          sizeHeaderImages();

		   $('.partner-logos-slider').slick({
		    infinite: true,
		    arrows: false,
		    slidesToShow: 5,
		    autoplay: true,
		    dots: true,
		   responsive: [
		    {
		      breakpoint: 768,
		      settings: {
		        slidesToShow: 3,
		        centerMode: true,
		      }
		    },

            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                dots: false,
              }
            },
		    ],
		  });

    postsSlider();

            //This option is for pages with a slider of images
    var lightbox = new SimpleLightbox('.image-gallery>.single-image>a', { /* options */ });
    var lightboxGrid = new SimpleLightbox('.image-gallery-grid>.single-image>a', { /* options */ });
    

    var windowWidth = $(window).width();

        if(windowWidth > 1170) {
            var centerPadAmount = (windowWidth - 1170) / 2;
        }

        else {
            var centerPadAmount = 20;
        }

        var lightboxGall = new SimpleLightbox('.image-gallery-extra>.single-image>a', { /* options */ });

        var gallerySlider = function($selector) { 

        var galleryArrows = $($selector).siblings('.gallery-arrows');
            
        $($selector).slick({
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: 2,
          autoplay:true,
          initialSlide: 0,
          centerMode: true,
          centerPadding: centerPadAmount + 'px',
          appendArrows: galleryArrows,
          //asNavFor: '.image-gallery',
          fade: false,
        responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: true,
                slidesToShow: 1,
              }
            }
            ],
        });
        }

        //gallerySlider('.image-gallery-header-slider');

        var imageGalleryExtra = $('.image-gallery-extra');

        $(imageGalleryExtra).each(function(){
            gallerySlider(this);
        });

        //This will create a lightbox gallery to replace the default wordpress gallery
         var galleryItems = $('figure.wp-block-gallery figure.wp-block-image');

          galleryItems.each(function() {
          
          var   caption = $(this).find( "figcaption" ),
                captionText = $(caption).text(),
                link = $(this).find( "a" ),
                image = $(this).find( "img" );
          $(image).attr('title', captionText);


          });
           // Galleries on Project Pages

           if($('figure.wp-block-gallery').length > 0) {
              var lightbox = new SimpleLightbox('figure.wp-block-gallery figure.wp-block-image a', {
                // captionSelector : 'figcaption',
                // captionType : 'text'
              });
            }
	});

//open and close search menu
$('button.search-toggle').on("click", function (event) {
    event.preventDefault();
    $('body').toggleClass('search-open');
    event.stopPropagation();
});

$(document).bind('keydown', function(e) {
	//alert(e.which);
    if (e.which == 27) {
        $('body').removeClass('search-open');
    }
}); 

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(document).ready(function(){
    $('.acf-map').each(function(){
        var map = initMap( $(this) );
    });
});


    $(window).on('load',function() {        
        // Animate loader off screen
        $("#loader").fadeOut(100);
    });

$(window).on('resize', function(){
    setTimeout(function() {
    sizeBoxes('.posts-slider header.article-header');
    sizeBoxes('.news-slider .post-lower');
    sizeHeaderImages();
    headerFunction();
 }, 300); 
});

    // On after slide change
        $('.news-slider').on('afterChange', function(slick, currentSlide){
            $('.news-slider .slick-slide').css('opacity','1');
            $('.news-slider .slick-slide.slick-current').prev().css('opacity','0');
        });

(function () {
  'use strict';

  var DEBUG = false; // set true for console logs
  var ITEM_SELECTOR = '.stat-single-number';
  var OUTER_SELECTOR = '.stat-single-outer';
  var DURATION_MS = 2000;
  var VISIBILITY_WAIT_TIMEOUT = 4000; // ms to wait for WOW/visibility before forcing animation

  function log() { if (!DEBUG) return; console.log.apply(console, arguments); }

  function parseNumber(text) {
    var clean = (text || '').toString().replace(/,/g, '').trim();
    var n = parseFloat(clean);
    return isFinite(n) ? Math.round(n) : 0;
  }

  var fmt = (function () {
    try {
      var nf = new Intl.NumberFormat('en-US');
      return function (n) { return nf.format(Math.round(n)); };
    } catch (e) {
      return function (n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ","); };
    }
  })();

  function animateValue(el, target, duration) {
    var start = 0;
    var startTime = null;
    el.textContent = fmt(0);
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var value = Math.floor(progress * (target - start) + start);
      el.textContent = fmt(value);
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }

  function isComputedVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    // offsetWidth/Height ensures element is laid out
    if (el.offsetWidth === 0 && el.offsetHeight === 0) return false;
    return true;
  }

  function findOuter(el) {
    var p = el;
    while (p) {
      if (p.classList && p.classList.contains(OUTER_SELECTOR.replace(/^\./, ''))) return p;
      p = p.parentElement;
    }
    return null;
  }

  function animateIfNeeded(el) {
    if (!el || el.__statAnimated) return;
    var target = parseNumber(el.textContent);
    log('Animating', el, 'target=', target);
    animateValue(el, target, DURATION_MS);
    el.__statAnimated = true;
  }

  function waitForVisibilityThenAnimate(el, timeout) {
    if (!el || el.__statAnimated) return;
    if (isComputedVisible(el)) {
      animateIfNeeded(el);
      return;
    }

    var outer = findOuter(el) || el;
    var done = false;
    var to;

    function cleanup() {
      done = true;
      if (mo) mo.disconnect();
      outer.removeEventListener('animationend', onAnimationEnd);
      clearTimeout(to);
    }

    function tryAnimate() {
      if (done) return;
      if (isComputedVisible(el)) {
        cleanup();
        animateIfNeeded(el);
      }
    }

    function onAnimationEnd() {
      // animationend fired on ancestor; re-check visibility
      setTimeout(tryAnimate, 20);
    }

    // Observe attribute/style/class changes on the outer container
    var mo = new MutationObserver(function () {
      tryAnimate();
    });
    mo.observe(outer, { attributes: true, attributeFilter: ['class', 'style'], childList: false, subtree: false });

    // Also listen for CSS animationend events (WOW.js uses CSS animation)
    outer.addEventListener('animationend', onAnimationEnd);

    // Failsafe: give up after timeout and animate anyway
    to = setTimeout(function () {
      if (done) return;
      cleanup();
      log('Visibility wait timed out, forcing animate for', el);
      animateIfNeeded(el);
    }, timeout || VISIBILITY_WAIT_TIMEOUT);
  }

  function initPerItemObserver() {
    var items = Array.prototype.slice.call(document.querySelectorAll(ITEM_SELECTOR));
    if (!items.length) {
      log('No items found for selector', ITEM_SELECTOR);
      return false;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var el = entry.target;
          if (!entry.isIntersecting) return;
          log('Intersecting:', el);
          // If it's computed-visible now, animate. If it's intersecting but hidden (WOW),
          // wait until it becomes visible (mutation/animationend) then animate.
          if (isComputedVisible(el)) {
            animateIfNeeded(el);
            io.unobserve(el);
          } else {
            // Wait for visibility, then unobserve when done (waitForVisibilityThenAnimate will do the animation)
            waitForVisibilityThenAnimate(el, VISIBILITY_WAIT_TIMEOUT);
            io.unobserve(el);
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.05
      });

      items.forEach(function (it) { io.observe(it); });

      // In case some items are already visible before observer attaches, IntersectionObserver should fire,
      // but call a quick synchronous pass for older browsers / edge cases:
      items.forEach(function (it) {
        if (isComputedVisible(it) && it.getBoundingClientRect().top <= (window.innerHeight || document.documentElement.clientHeight)) {
          // animate immediately if visible
          animateIfNeeded(it);
          try { io.unobserve(it); } catch (e) { /* ignore */ }
        }
      });

      return true;
    }
    return false;
  }

  // jQuery fallback: per-item checks + visibility wait
  function initJQueryFallback() {
    if (typeof jQuery === 'undefined') return;
    jQuery(function ($) {
      var $items = $(ITEM_SELECTOR);
      if ($items.length === 0) return;
      function inView($el) {
        var rect = $el[0].getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        return rect.top <= vh - 50 && rect.bottom >= 0;
      }
      function runChecks() {
        $items.each(function () {
          var el = this;
          var $el = $(el);
          if ($el.data('stat-animated')) return;
          if (inView($el)) {
            $el.data('stat-animated', true);
            if (isComputedVisible(el)) {
              animateIfNeeded(el);
            } else {
              waitForVisibilityThenAnimate(el, VISIBILITY_WAIT_TIMEOUT);
            }
          }
        });
        if ($items.filter(function () { return $(this).data('stat-animated'); }).length === $items.length) {
          $(window).off('scroll.statsCounter resize.statsCounter load.statsCounter');
        }
      }
      $(window).on('scroll.statsCounter resize.statsCounter load.statsCounter', runChecks);
      runChecks();
    });
  }

  // Init: prefer IntersectionObserver per-item, fallback to jQuery per-item, otherwise animate all
  var used = initPerItemObserver();
  if (!used) {
    initJQueryFallback();
    // if no jQuery either, animate everything after small timeout (ensures DOM ready)
    if (typeof IntersectionObserver === 'undefined' && typeof jQuery === 'undefined') {
      setTimeout(function () {
        document.querySelectorAll(ITEM_SELECTOR).forEach(function (el) {
          if (!el.__statAnimated) animateIfNeeded(el);
        });
      }, 150);
    }
  }

})();

$('#tm-filters button').on('click',function(event){
    var dataTarget = $(this).data('tm-target');

     $('#tm-filters button').removeClass('active-filter');
     $(this).addClass('active-filter');

    $('.tm-with-filters').hide();
        $(dataTarget).each(function(){
            $(this).fadeIn(300);
    })
});


})( jQuery );

// tm-filters.js
// Optional helper: toggles .no-scroll on .tm-filters-inner when content does not overflow.
// Include this script on the page where the filters are rendered (after the DOM).
(function () {
  'use strict';

  var selector = '#tm-filters .tm-filters-inner';

  function updateScrollState(el) {
    if (!el) return;
    // if scrollWidth is greater than clientWidth there is overflow
    var hasOverflow = el.scrollWidth > el.clientWidth + 1; // +1 tolerance for rounding
    if (hasOverflow) {
      el.classList.remove('no-scroll');
    } else {
      el.classList.add('no-scroll');
    }
  }

  function init() {
    var el = document.querySelector(selector);
    if (!el) return;

    // initial state
    updateScrollState(el);

    // update on resize and when content may change. debounce to avoid thrash.
    var timeout;
    function tick() {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        updateScrollState(el);
      }, 80);
    }

    window.addEventListener('resize', tick);
    // Fire on scroll so overlay can be hidden if user scrolls to the end
    el.addEventListener('scroll', tick);

    // If your terms are injected dynamically, observe DOM changes
    if (window.MutationObserver) {
      var mo = new MutationObserver(tick);
      mo.observe(el, { childList: true, subtree: false, characterData: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();